import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Api } from '../../services/api';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { MdArchive } from 'react-icons/md';
import { BiSolidArchiveOut } from 'react-icons/bi';
import { FaReplyAll, FaTrash, } from 'react-icons/fa';


const Performance = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReminderBoxOpen, setIsReminderBoxOpen] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const toast = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [formList, setFormList] = useState([]);
    const [archiveFormList, setArchiveFormList] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState(null);
    //! ----------------

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [conversationId, setConversationId] = useState(null);
    const [conversationIdResend, setConversationIdResend] = useState(null);
    const [conversationType, setConversationType] = useState(null);

    const [reason, setReason] = useState('');
    const [reminderReason, setReminderReason] = useState('');

    const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to Archive this project?');
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
        useState(false);

    const [isResendEmailModalOpen, setIsResendEmailModalOpen] = useState(false);

    const [roleId, setRoleId] = useState(null);
    //! ----------------

    //* ----------------   
    /** search Filtter function Start */

    // const [filters, setFilters] = useState(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            // global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            // project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            // first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            // last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            // ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        });
        setGlobalFilterValue('');
    };
    /** search Filtter function End */
    //! ----------------


    const header = (
        <div className="flex flex-wrap align-items-center justify-content-end m-2">

            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder="Search..."
                />
            </span>
        </div>
    );



    const openEditModal = (event) => {
        console.log('event', event);

        localStorage.setItem('quarterlyHuddleConRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))

        localStorage.setItem('quarterlyHuddleConSelectedProduct', JSON.stringify(event))

        navigate('/form/' + event.slug)
    };



    useEffect(() => {
        // Fetch form data here...
        if (location.state?.selectedId) {
            // Automatically select the row with the passed identifier
            const selectedId = location.state.selectedId;
            const selectedForm = formList.find(form => form.id === selectedId);
            setSelectedProduct(selectedForm);
        }
    }, [location.state, formList]);

    useEffect(() => {
        getFormData();
        const storedRoleId = localStorage.getItem('role_id');
        setRoleId(storedRoleId);
        initFilters();
    }, []);

    const getFormData = async () => {

        var user_id = localStorage.getItem('user_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };


        var _body = {
            user_id: user_id,

        }

        fetch(Api.API_BASE_URL + '555/get-all-data-for-admin', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(_body),

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                // console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    // setFormList(response.result)
                    // setArchiveFormList(response.archive)

                    // *-------Suraj Code for Shorting-----------
                    const sortedFormList = response.result.sort((a, b) => new Date(b.date) - new Date(a.date));
                    const sortedArchiveFormList = response.archive.sort((a, b) => new Date(b.date) - new Date(a.date));
                    setFormList(sortedFormList);
                    setArchiveFormList(sortedArchiveFormList);


                    // !-------Suraj Code -----------

                    let playbookRedirect = localStorage.getItem('quarterlyHuddleConRedirect');
                    if (playbookRedirect) {
                        playbookRedirect = JSON.parse(playbookRedirect)
                        setFirst(playbookRedirect.first || 0)
                        setRows(playbookRedirect.rows || 12)
                        setSortField(playbookRedirect.sortField || 'quater')
                        setSortOrder(playbookRedirect.sortOrder || -1)

                    }
                    let playbookSelectedProduct = localStorage.getItem('quarterlyHuddleConSelectedProduct');


                    if (playbookSelectedProduct) {
                        playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                        setSelectedRowData(playbookSelectedProduct)
                    }

                    localStorage.removeItem('quarterlyHuddleConSelectedProduct')
                    localStorage.removeItem('quarterlyHuddleConRedirect');
                }
            })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log({
            supervisor_name: selectedRowData.supervisor_name,
            status: 'Request',
            reason: reason
        });


        var userId = localStorage.getItem('user_id');

        fetch(Api.API_BASE_URL + '555/request', {
            method: 'POST',

            body: JSON.stringify({

                userId: userId,
                conversationId: conversationId,
                conversationType: conversationType,
                reason: reason,
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response data
                console.log('Success:', data);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                setIsModalOpen(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    const handleReminderSubmit = (e) => {
        e.preventDefault();


        var user_id = localStorage.getItem('user_id');


        console.log({
            user_id: user_id,
            status: 'Request',
            reminderReason: reminderReason
        });



        fetch(Api.API_BASE_URL + '555/get-for-all', {
            method: 'POST',

            body: JSON.stringify({

                user_id: user_id,

                reason: reminderReason,
            }),
        })
            .then(response => response.json())
            .then(data => {

                console.log('Success:', data);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                setIsReminderBoxOpen(false);
                getFormData();
                // ----------Reload -----------
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    // ---------------------------------------------------------------------------------
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={(e) => e.stopPropagation()}>

                    {/* <FaTrash title='Archive' onClick={() => handleDeleteProject(rowData.id)} style={{ color: 'darkred' }} /> */}
                    <FaTrash title='Permanent Delete' onClick={() => handleDeleteProject(rowData.id, 'permanentDelete')} style={{ color: 'darkred', fontSize: '18px', marginRight: '10px', }} />

                    {activeIndex === 0 ? (
                        <>
                            <MdArchive title='Archive' onClick={() => handleDeleteProject(rowData.id, 'archive')} style={{ color: 'black', fontSize: '24px', paddingTop: '4px' }} />

                            <FaReplyAll size={20} title='Resend email' onClick={() => handleResendEmail(rowData)} style={{ color: '#0D92F4', marginLeft: '10px', }} />
                        </>
                    ) : (
                        <BiSolidArchiveOut title='Restore' onClick={() => handleDeleteProject(rowData.id, 'restore')} style={{ color: 'green', fontSize: '24px', paddingTop: '4px' }} />
                    )}


                </div>
            </React.Fragment>
        );
    };


    const onRowSelect = (e) => {
        console.log(e.data)
        const rowData = e.data;
        openEditModal(rowData);
        setSelectedRowData(rowData);
    };

    //* -------------------------
    const handleDeleteProject = (projectId, type) => {

        setDeletionType(type);
        setProjectDeleteTitle(type === 'archive' ? 'Are you sure you want to Archive this project?' : type === 'permanentDelete' ? 'Are you sure you want to Permanent Delete this project?' : 'Are you sure you want to Active this project?');

        setIsDeleteConfirmationModalOpen(true);
        setConversationId(projectId);
    };
    const [deletionType, setDeletionType] = useState(null);
    // const handleDeleteProject = (projectId,) => {

    //     setProjectDeleteTitle('Are you sure you want to Archive this project?');

    //     setIsDeleteConfirmationModalOpen(true);
    //     setConversationId(projectId);
    // };
    //! -------------------------


    const confirmDelete = async () => {
        var user_id = localStorage.getItem('user_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };


        var _body = {
            user_id: user_id,

            conversationId: conversationId,
            // conversationId: 1212112,
            status: deletionType === 'permanentDelete' ? 'PERMANENT_DELETE' : deletionType === 'archive' ? 'ARCHIVE' : 'ACTIVE'

        }

        fetch(Api.API_BASE_URL + '555/status-update', {
            method: 'POST',
            headers:headers,
            body: JSON.stringify(_body),

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form deleted successfully', life: 3000 });
                    getFormData();
                    setIsDeleteConfirmationModalOpen(false);
                }
            })
    }

    //* -------------------------
    const handleResendEmail = (projectId) => {
        setIsResendEmailModalOpen(true);
        setConversationIdResend(projectId);
    };

    const handleEmailSend = (rowData) => {
        console.log(rowData)
        var user_id = localStorage.getItem('user_id');
        var _body = {
            user_id: user_id,
            id: conversationIdResend.id
        }

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };


        fetch(Api.API_BASE_URL + '555/resend-convertion-mail', {
            method: 'POST',
            body: JSON.stringify(_body),
            headers:headers,

        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Email sent successfully', life: 3000 });
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to send email', life: 3000 });
            });
    };


    //! -------------------------

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
        setIsResendEmailModalOpen(false);
    };

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(12);
    const [sortField, setSortField] = useState('quater');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }

    return (
        <>


            <div className="pagee-container">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Active" className="p-2 pb-2" >
                                <DataTable
                                    value={formList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}

                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}
                                    // onSelectionChange={(e) => setSelectedProduct(e.value)}
                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}

                                    emptyMessage="No records found"
                                >

                                    <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', textAlign: 'center' }}></Column>

                                    <Column field="team_member_name" sortable header="User" ></Column>
                                    <Column field="supervisor_name" sortable header="Supervisor Name" ></Column>
                                    <Column field="date" sortable header="Date"></Column>
                                    <Column field="quater" sortable header="Quarter" body={(e) => {
                                        let quarterText = '';
                                        let backgroundColor = '';
                                        switch (e.quater) {
                                            case 'Q1':
                                                quarterText = 'Quarter 1';
                                                backgroundColor = '#FF6384';
                                                break;
                                            case 'Q2':
                                                quarterText = 'Quarter 2';
                                                backgroundColor = '#36A2EB';
                                                break;
                                            case 'Q3':
                                                quarterText = 'Quarter 3';
                                                backgroundColor = '#FFCE56';
                                                break;
                                            case 'Q4':
                                                quarterText = 'Quarter 4';
                                                backgroundColor = '#4BC0C0';
                                                break;
                                            default:
                                                quarterText = '';
                                                backgroundColor = 'transparent';
                                        }
                                        return <span style={{ backgroundColor, padding: '4px 8px', borderRadius: '4px', color: backgroundColor === '#FFCE56' ? 'white' : 'white' }}>{quarterText}</span>;
                                    }}
                                        style={{ textAlign: 'center' }}

                                    ></Column>
                                    <Column field="year" sortable header="Year"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>

                                </DataTable>
                            </TabPanel>


                            <TabPanel header="Archive" className="p-2 pb-2" >
                                <DataTable
                                    value={archiveFormList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}

                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}

                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}

                                    emptyMessage="No records found"
                                >
                                    <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '120px', textAlign: 'center' }}></Column>

                                    <Column field="team_member_name" sortable header="User" className="col-padding" ></Column>
                                    <Column field="supervisor_name" sortable header="Supervisor Name" className="col-padding" ></Column>

                                    <Column field="date" sortable header="Date" className="col-padding"></Column>


                                    <Column field="quater" sortable header="Quarter" body={(e) => {
                                        let quarterText = '';
                                        let backgroundColor = '';
                                        switch (e.quater) {
                                            case 'Q1':
                                                quarterText = 'Quarter 1';
                                                backgroundColor = '#FF6384';
                                                break;
                                            case 'Q2':
                                                quarterText = 'Quarter 2';
                                                backgroundColor = '#36A2EB';
                                                break;
                                            case 'Q3':
                                                quarterText = 'Quarter 3';
                                                backgroundColor = '#FFCE56';
                                                break;
                                            case 'Q4':
                                                quarterText = 'Quarter 4';
                                                backgroundColor = '#4BC0C0';
                                                break;
                                            default:
                                                quarterText = '';
                                                backgroundColor = 'transparent';
                                        }
                                        return <span style={{ backgroundColor, padding: '4px 8px', borderRadius: '4px', color: backgroundColor === '#FFCE56' ? 'black' : 'white' }}>{quarterText}</span>;
                                    }}
                                        style={{ textAlign: 'center' }}

                                    ></Column>
                                    <Column field="year" sortable header="Year" className="col-padding"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>



                                </DataTable>
                            </TabPanel>
                        </TabView>
                    )}
                </div>
            </div>

            {/* // --------------------------------dialog Box------------------------------------------------------ */}

            <Dialog header="" visible={isModalOpen} style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsModalOpen(false)}>

                {selectedRowData && (
                    <div className='card'>
                        <form onSubmit={handleSubmit} className="" >
                            <div className=" formgrid grid">
                                <div className="col-6 pt-2">
                                    <p>Supervisor Name: <strong className='text-xl'> {selectedRowData.supervisor_name} </strong></p>
                                </div>

                                <div className="col-12 pt-2">
                                    <label htmlFor="reason">Reason</label>
                                    <textarea
                                        id="reason"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        className="p-inputtext p-component"
                                        style={{ width: '100%', height: '100px' }}
                                    />
                                </div>

                                <div className="card flex flex-wrap justify-content-center gap-3">
                                    <Button label="Submit" type="submit" className="p-2" />
                                </div>

                            </div>
                        </form>
                    </div>
                )}
            </Dialog>

            {/* // --------------------------------Reminder Box------------------------------- */}
            <Dialog header="" visible={isReminderBoxOpen} style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsReminderBoxOpen(false)}>

                <div className='card'>
                    <form onSubmit={handleReminderSubmit} className="" >
                        <div className=" formgrid grid">
                            <div className="col-6">
                                <strong>Custom Message : </strong>
                            </div>

                            <div className="col-12 pt-2">
                                <textarea
                                    id="reason"
                                    value={reminderReason}
                                    onChange={(e) => setReminderReason(e.target.value)}
                                    className="p-inputtext p-component"
                                    style={{ width: '100%', height: '100px' }}
                                />
                            </div>

                            <div className="card flex flex-wrap justify-content-center gap-3">
                                <Button label="Submit" type="submit" className="p-2" />
                            </div>

                        </div>
                    </form>
                </div>

            </Dialog>

            {/* // --------------------------------DELETE Box------------------------------------ */}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">
                                {deletionType === 'permanentDelete' ? 'Permanent Delete Confirmation' : activeIndex === 0 ? 'Archive Confirmation' : 'Active Confirmation'}
                            </h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>
                                {deletionType === 'permanentDelete' ? 'Are you sure you want to Permanent Delete this project?' : activeIndex === 0 ? projectDeletetitle : 'Are you sure you want to Active this project?'}
                            </p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className={deletionType === 'permanentDelete' ? "delete-buttonx" : activeIndex === 0 ? "delete-buttonx" : "save-buttonx"} onClick={confirmDelete}>
                                {deletionType === 'permanentDelete' ? 'Delete' : activeIndex === 0 ? 'Archive' : 'Active'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isResendEmailModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Resend Email Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>Are you sure you want to resend the email?</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="save-buttonx" onClick={handleEmailSend}>
                                Resend Email
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default Performance